import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';

import { CookieName } from './cookie/cookie.models';
import { CookieService } from './cookie/cookie.service';
import { WINDOW } from './window/window.token';

/**
 * @whatItDoes Provides information about PWA related features.
 *
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class PWAService {
    private readonly window = inject(WINDOW);
    private readonly breakpointObserver = inject(BreakpointObserver);
    private readonly cookieService = inject(CookieService);

    private readonly standaloneMediaMatch = this.breakpointObserver.isMatched('(display-mode: standalone)');
    private readonly standaloneNavigator: boolean = (this.window.navigator as any).standalone;
    private readonly standaloneOverrideCookie = this.cookieService.get(CookieName.StandaloneOverride) === '1';

    readonly isStandaloneApp = this.standaloneMediaMatch || this.standaloneNavigator || this.standaloneOverrideCookie;
}
